"use strict";
var EnumUtil = (function () {
    function EnumUtil() {
    }
    EnumUtil.getNames = function (e) {
        return Object.keys(e).filter(function (v) { return isNaN(parseInt(v, 10)); });
    };
    EnumUtil.getValues = function (e) {
        return Object.keys(e).map(function (v) { return parseInt(v, 10); }).filter(function (v) { return !isNaN(v); });
    };
    EnumUtil.getNamesAndValues = function (e) {
        return EnumUtil.getValues(e).map(function (v) { return { name: e[v], value: v }; });
    };
    EnumUtil.getValuesByName = function (e) {
        return EnumUtil.getValues(e).reduce(function (result, v) {
            result[e[v]] = v;
            return result;
        }, {});
    };
    return EnumUtil;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = EnumUtil;
